export default __webpack_public_path__ + "locales/fr/DeleteDialog.json?hash=70f3f5a02f80faf3c48a8d7d5a916536";